import { render, staticRenderFns } from "./applyfrom.vue?vue&type=template&id=4c64eb90&"
import script from "./applyfrom.vue?vue&type=script&lang=js&"
export * from "./applyfrom.vue?vue&type=script&lang=js&"
import style0 from "./applyfrom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports